webpackJsonp([68671685732945],{

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(4);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formik = __webpack_require__(10);
	
	var _yup = __webpack_require__(13);
	
	var Yup = _interopRequireWildcard(_yup);
	
	var _Alert = __webpack_require__(14);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _CheckboxGroup = __webpack_require__(17);
	
	var _CheckboxGroup2 = _interopRequireDefault(_CheckboxGroup);
	
	var _Input = __webpack_require__(9);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _RadioGroup = __webpack_require__(16);
	
	var _RadioGroup2 = _interopRequireDefault(_RadioGroup);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _ResponsiveVid = __webpack_require__(21);
	
	var _ResponsiveVid2 = _interopRequireDefault(_ResponsiveVid);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Datetime = __webpack_require__(18);
	
	var _Datetime2 = _interopRequireDefault(_Datetime);
	
	var _moment = __webpack_require__(12);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Form2021marketingguide = function (_Component) {
	  _inherits(Form2021marketingguide, _Component);
	
	  function Form2021marketingguide(props) {
	    _classCallCheck(this, Form2021marketingguide);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      formState: null
	    };
	    return _this;
	  }
	
	  Form2021marketingguide.prototype.render = function render() {
	    var _this2 = this;
	
	    var formState = this.state.formState;
	    var _props = this.props,
	        classes = _props.classes,
	        className = _props.className;
	
	
	    var valid = function valid(current) {
	      return current.day() !== 0 && current.day() !== 6;
	    };
	
	    var renderDay = function renderDay(props, currentDate, selectedDate) {
	      if (currentDate.month() == (0, _moment2.default)().month()) {
	        if (currentDate.date() < (0, _moment2.default)().date()) {
	          if (props.className == "rdtDay") {
	            props.className = "rdtDay rdtDisabled";
	          }
	        }
	      }
	      if (currentDate.month() < (0, _moment2.default)().month()) {
	        props.className = "rdtDay rdtDisabled";
	      }
	
	      return _react2.default.createElement(
	        "td",
	        props,
	        currentDate.date()
	      );
	    };
	
	    if (formState === "success") {
	      return _react2.default.createElement(
	        "div",
	        {
	          style: {
	            maxWidth: "600px",
	            textAlign: "center",
	            margin: "24px auto"
	          }
	        },
	        _react2.default.createElement(
	          "div",
	          null,
	          _react2.default.createElement(
	            _Typography2.default,
	            {
	              type: "heading3",
	              gutterBottom: true,
	              style: { color: "#f15623" }
	            },
	            "Fantastic!"
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { margin: "50px" } },
	            _react2.default.createElement(
	              "a",
	              {
	                className: classes.signUpBtn,
	                href: "/assets/2021_marketing_guide.pdf"
	              },
	              "Download the PDF"
	            )
	          )
	        )
	      );
	    } else if (formState === "error") {
	      return _react2.default.createElement(
	        "div",
	        { style: { maxWidth: "400px", margin: "24px auto" } },
	        _react2.default.createElement(
	          _Alert2.default,
	          { color: "error" },
	          "An error occurred."
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)(classes.root, className) },
	      _react2.default.createElement(_formik.Formik, {
	        initialValues: {
	          firstname: "",
	          lastname: "",
	          company: "",
	          email: "",
	          phone: "",
	          mls_number: "",
	          form: "2021marketingguide",
	          list: 120590,
	          meetingdate: "",
	          meetingtime: "",
	          role: "",
	          interests: ""
	        },
	        validationSchema: function validationSchema() {
	          return Yup.object().shape({
	            firstname: Yup.string().required("First name is required"),
	            lastname: Yup.string().required("Last name is required"),
	            company: Yup.string(),
	            email: Yup.string().email("Invalid email address").required("Email is required"),
	            phone: Yup.string().required("Phone is required"),
	            mls_number: Yup.string()
	          });
	        },
	        onSubmit: function onSubmit(values, _ref) {
	          var setSubmitting = _ref.setSubmitting;
	
	          //if (values.meetingdate != undefined) {
	          var meeting_request = "";
	          var notes = "Interests: ";
	          Object.keys(values).forEach(function (key, index) {
	            // key: the name of the object key
	            // index: the ordinal position of the key within the object
	            if (key == "meetingdate") {
	              if (typeof values.meetingdate.format === "function") {
	                meeting_request = values.meetingdate.format("YYYY-MM-DD") + "T" + values.meetingtime.replace(" (EDT)", "") + "-04:00";
	              }
	            }
	            if (key == "roleOther") {
	              if (values.roleOther.length > 0) {
	                values.role = values.roleOther;
	              }
	            }
	            if (key == "interestsOther") {
	              if (values.interestsOther.length > 0) {
	                //notes = values.interests.join(",");
	                notes = notes + "," + values.interestsOther;
	              }
	            }
	            if (key == "interests") {
	              if (values.interests.length > 0) {
	                notes = notes + "," + values.interests.join(",");
	              }
	            }
	            if (key == "demorequest") {
	              if (values.demorequest) {
	                notes = notes + ", Requesting 15 min demo";
	              }
	            }
	          });
	
	          var body = _extends({}, values, {
	            notes: notes,
	            utm_campaign: window.utm_tags ? window.utm_tags.campaign : "",
	            utm_source: window.utm_tags ? window.utm_tags.source : "",
	            utm_medium: window.utm_tags ? window.utm_tags.medium : "",
	            utm_term: window.utm_tags ? window.utm_tags.term : "",
	            demo_request_date: meeting_request
	          });
	          return fetch("https://hooks.zapier.com/hooks/catch/4496703/3uy9gh0/", {
	            method: "POST",
	            body: JSON.stringify(body)
	          }).then(function (response) {
	            return response.json();
	          }).then(function (res) {
	            if (res.status === "success") {
	              _this2.setState({ formState: "success" });
	              dataLayer.push({ event: "form-success" });
	
	              if (window.fbq) {
	                window.fbq("track", "Lead");
	              }
	              if (window.gtag) {
	                window.gtag("event", "conversion", {
	                  send_to: "AW-980447970/2_aHCOnsjo8BEOLlwdMD"
	                });
	              }
	              if (window.ga) {
	                window.ga("send", "event", "form", "form_completed", "bright");
	              }
	            } else {
	              _this2.setState({ formState: "error" });
	            }
	          }).catch(function (err) {
	            _this2.setState({ formState: "error" });
	          });
	        },
	        render: function render(_ref2) {
	          var values = _ref2.values,
	              isSubmitting = _ref2.isSubmitting,
	              handleBlur = _ref2.handleBlur,
	              handleChange = _ref2.handleChange;
	          return _react2.default.createElement(
	            _formik.Form,
	            { noValidate: true },
	            _react2.default.createElement("div", { style: { marginBottom: "30px" } }),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  maxWidth: "600px",
	                  marginLeft: "auto",
	                  marginRight: "auto"
	                }
	              },
	              _react2.default.createElement(
	                "div",
	                { className: classes.topRow },
	                _react2.default.createElement(_formik.Field, {
	                  id: "firstname",
	                  name: "firstname",
	                  label: "First Name",
	                  component: _Input2.default,
	                  className: classes.field
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "lastname",
	                  name: "lastname",
	                  label: "Last Name",
	                  component: _Input2.default,
	                  className: classes.field
	                })
	              ),
	              _react2.default.createElement(_formik.Field, {
	                id: "email",
	                name: "email",
	                label: "Email",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "phone",
	                name: "phone",
	                label: "Phone",
	                component: _Input2.default,
	                className: classes.field,
	                type: "tel"
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "company",
	                name: "company",
	                label: "Affiliation (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(_formik.Field, {
	                id: "mls_number",
	                name: "mls_number",
	                label: "MLS # (optional)",
	                component: _Input2.default,
	                className: classes.field
	              }),
	              _react2.default.createElement(
	                "div",
	                {
	                  style: {
	                    textAlign: "left",
	                    fontSize: "14px",
	                    lineHeight: "19px"
	                  }
	                },
	                _react2.default.createElement(_formik.Field, {
	                  id: "role",
	                  name: "role",
	                  label: "I am:",
	                  component: _RadioGroup2.default,
	                  display: "inline",
	                  items: [{
	                    label: "An Existing Client",
	                    value: "Existing Client"
	                  }, {
	                    label: "An Agent",
	                    value: "Agent"
	                  }, {
	                    label: "A Broker/Owner",
	                    value: "Broker/Owner"
	                  }, {
	                    label: "Other (please specify)",
	                    value: "Other"
	                  }],
	                  className: classes.field
	                }),
	                values.role === "Other" && _react2.default.createElement(_formik.Field, {
	                  id: "roleOther",
	                  name: "roleOther",
	                  label: "Other",
	                  component: _Input2.default,
	                  className: classes.field,
	                  autoFocus: true
	                }),
	                _react2.default.createElement(_formik.Field, {
	                  id: "demorequest",
	                  name: "demorequest",
	                  type: "checkbox",
	                  value: "yes",
	                  className: classes.checkfield,
	                  style: { marginLeft: "0px", marginRight: "15px" }
	                }),
	                _react2.default.createElement(
	                  "span",
	                  { style: { fontSize: "16px" } },
	                  "Schedule a 15-minute demo of Elevate"
	                )
	              ),
	              _react2.default.createElement(
	                "button",
	                {
	                  type: "submit",
	                  className: classes.signUpBtn,
	                  disabled: isSubmitting
	                },
	                "Get Download"
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                style: {
	                  fontSize: "11px",
	                  paddingBottom: "35px",
	                  lineHeight: "16px"
	                }
	              },
	              "By submitting this form, you are requesting to be contacted by a member of the Elevate Sales Team at the details provided via text, email or call (may involve automated or pre-recorded means). You may revoke this consent through any reasonable means.",
	              _react2.default.createElement("br", null),
	              "Existing subscribers seeking support, please visit the",
	              " ",
	              _react2.default.createElement(
	                "a",
	                { href: "https://support.tryelevate.com/s/ " },
	                "Elevate Help Center"
	              ),
	              "."
	            )
	          );
	        }
	      })
	    );
	  };
	
	  return Form2021marketingguide;
	}(_react.Component);
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _fullWidthVid;
	
	  return {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      maxWidth: "700px",
	      margin: "0 auto",
	      textAlign: "center"
	    },
	    link: {
	      color: "inherit"
	    },
	    field: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "50px",
	      fontWeight: "600",
	      textAlign: "left"
	    },
	    topRow: {
	      display: "flex",
	      flexDirection: "row",
	      justifyContent: "space-between",
	
	      "& > * + *": {
	        marginLeft: "12px"
	      }
	    },
	    headingSmall: {
	      fontSize: "20px",
	      textTransform: "uppercase",
	      fontWeight: "600",
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px"
	    },
	    headingLarge: {
	      fontSize: "33px",
	      fontWeight: "700",
	      color: "#5bc0b8",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "38px"
	    },
	    headingText: {
	      color: "#777777",
	      textAlign: "center",
	      padding: "3px",
	      lineHeight: "1.4em"
	    },
	    checkfield: {
	      width: "20px",
	      height: "20px",
	      position: "relative",
	      top: "4px",
	      marginLeft: "10px"
	    },
	    signUpBtn: {
	      width: "60%",
	      fontSize: "18px",
	      lineHeight: "26px",
	      fontWeight: "600",
	      color: "#FFF",
	      backgroundColor: "#5bc0b8",
	      borderRadius: "6px",
	      padding: "12px",
	      marginTop: "30px",
	      marginBottom: "30px",
	      textDecoration: "none"
	    },
	    selectfield: {
	      borderRadius: "6px",
	      border: "2px solid #ECECEC",
	      height: "40px"
	    },
	    selectlabel: {
	      width: "100%",
	      color: "#888f96",
	      display: "flex",
	      fontSize: "14px",
	      alignItems: "center",
	      lineHeight: "18px",
	      fontWeight: "700",
	      marginBottom: "4px"
	    },
	
	    fullWidthVid: (_fullWidthVid = {
	      width: "100%",
	      marginLeft: "auto",
	      marginRight: "auto"
	    }, _fullWidthVid[theme.breakpoints[900]] = {
	      width: "75%"
	    }, _fullWidthVid)
	  };
	})(Form2021marketingguide);
	module.exports = exports["default"];

/***/ }),

/***/ 3022:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2021_logo.b9ae0949.png";

/***/ }),

/***/ 1748:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _withStyles = __webpack_require__(3);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _siteConfig = __webpack_require__(7);
	
	var _siteConfig2 = _interopRequireDefault(_siteConfig);
	
	var _Container = __webpack_require__(5);
	
	var _Container2 = _interopRequireDefault(_Container);
	
	var _ResponsiveVid = __webpack_require__(21);
	
	var _ResponsiveVid2 = _interopRequireDefault(_ResponsiveVid);
	
	var _Form2021marketingguide = __webpack_require__(1549);
	
	var _Form2021marketingguide2 = _interopRequireDefault(_Form2021marketingguide);
	
	var _SEO = __webpack_require__(6);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _logo = __webpack_require__(3022);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Your2021marketingguide = function Your2021marketingguide(_ref) {
	  var children = _ref.children,
	      classes = _ref.classes,
	      data = _ref.data,
	      tags = _ref.tags;
	
	  var postNode = {
	    title: "Your 2021 Marketing Strategy Guide - " + _siteConfig2.default.siteTitle
	  };
	
	  return _react2.default.createElement(
	    "div",
	    { className: classes.root },
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Your 2021 Marketing Strategy Guide - " + _siteConfig2.default.siteTitle
	      )
	    ),
	    _react2.default.createElement(_SEO2.default, { postNode: postNode, pagePath: "Your 2021 Marketing Strategy Guide", customTitle: true }),
	    _react2.default.createElement(
	      _Container2.default,
	      null,
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { maxWidth: "900px", backgroundColor: "#f7f7f7", marginRight: "auto", marginLeft: "auto", paddingTop: "35px", textAlign: "center" } },
	          _react2.default.createElement(
	            "div",
	            { style: { paddingLeft: "65px", paddingRight: "65px" } },
	            _react2.default.createElement("img", { src: _logo2.default, width: "100%", style: { paddingBottom: "45px", paddingTop: "20px", maxWidth: "538px", textAlign: "center" } }),
	            _react2.default.createElement(
	              "h1",
	              { className: classes.Heading },
	              "Download Your FREE, Marketing Strategy Guide",
	              _react2.default.createElement("br", null),
	              "to Get 2021 Started Right!"
	            ),
	            _react2.default.createElement(
	              "div",
	              { style: { color: "#495050", lineHeight: "26px", textAlign: "center", paddingBottom: "35px" } },
	              "Planning your goals, budget and overarching marketing strategy can feel like daunting work, but it\u2019s a crucial part of running a successful business.  This FREE guide from the experts at Elevate is designed to help you focus on what\u2019s important, and to encourage you to expand your marketing for the new year."
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { style: { paddingLeft: "10px", paddingRight: "10px" } },
	            _react2.default.createElement(_Form2021marketingguide2.default, null)
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = (0, _withStyles2.default)(function (theme) {
	  var _fullWidthVid, _ref2;
	
	  return _ref2 = {
	    root: {
	      display: "flex",
	      flexDirection: "column",
	      width: "100%",
	      padding: "0 8px",
	      marginLeft: "auto",
	      marginRight: "auto",
	      marginTop: "0px",
	      marginBottom: "70px"
	    },
	
	    Heading: {
	      fontSize: "28px",
	      fontWeight: "700",
	      lineHeight: "36px",
	      letterSpacing: ".14px",
	      color: "#55c3ba",
	      textAlign: "center",
	      marginBottom: "18px"
	    },
	
	    fullWidthVid: (_fullWidthVid = {
	      width: "100%",
	      marginLeft: "auto",
	      marginRight: "auto"
	    }, _fullWidthVid[theme.breakpoints[900]] = {
	      width: "75%"
	    }, _fullWidthVid),
	
	    subHeading: {
	      fontSize: "18px",
	      lineHeight: "28px",
	      fontWeight: "600",
	      letterSpacing: ".08px",
	      color: "#888f96",
	      textAlign: "center",
	      margin: "0 auto 36px"
	    }
	
	  }, _ref2["subHeading"] = {
	    fontSize: "18px",
	    lineHeight: "28px",
	    letterSpacing: ".08px",
	    textAlign: "center",
	    margin: "0 auto 36px"
	  }, _ref2.landingHeaderStyle = {
	    textAlign: "center",
	    marginBottom: "30px"
	  }, _ref2;
	})(Your2021marketingguide);
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-your-2021-marketingguide-js-451773445375e118411a.js